import axios from "axios";

const envUrl = process.env.REACT_APP_API_URL;
export const API_BASE_URL =
  envUrl && !envUrl.includes("7006") ? envUrl : "https://orbitell.in/api";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to attach JWT token
axiosInstance.interceptors.request.use(
  (config) => {
    const token =
      sessionStorage.getItem("token") || localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle global errors (like 401 Unauthorized).
// Only force a logout+redirect when the failed request actually carried a
// token that got rejected (expired/invalid session) — a 401 from a login
// endpoint itself just means "wrong credentials" and must NOT wipe/redirect,
// or it stomps the login form's own error message with a surprise navigation.
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const hadToken = !!error.config?.headers?.Authorization;
    if (error.response && error.response.status === 401 && hadToken) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/register"; // Redirect to login/register
    }
    return Promise.reject(error);
  },
);

export const handleResponse = async (promise) => {
  try {
    const response = await promise;
    return response.data;
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "An unexpected error occurred.";
    throw new Error(message);
  }
};

export const getUploadUrl = (path) => {
  if (!path) return "";
  if (
    path.startsWith("http://") ||
    path.startsWith("https://") ||
    path.startsWith("data:") ||
    path.startsWith("blob:")
  ) {
    return path;
  }
  const backendBase = API_BASE_URL.replace(/\/api\/?$/, "");
  return `${backendBase}${path.startsWith("/") ? "" : "/"}${path}`;
};

export default axiosInstance;
